import Select from 'Components/Forms/Select';
import React from 'react';
import LabelBadge, { getStatusVariant } from './LabelBadge';
import { FormField, StyledCommentsField } from './reportStyles';
import { STATUS_OPTIONS, statusName } from './utils';

const FinalReport = props => {
    const { finalComments, finalStatus, finalValidated } = props;
    const { onFinalCommentsChange, onFinalStatusChange } = props;

    if (finalValidated) {
        return (
            <>
                <div style={{ marginTop: 16 }}>
                    <LabelBadge label={statusName(finalStatus)} variant={getStatusVariant(finalStatus)}/>
                </div>
                {finalComments && (
                    <div style={{ fontSize: '0.65rem', whiteSpace: 'pre-wrap', marginTop: 12 }}>
                        {finalComments}
                    </div>
                )}
            </>
        );
    }

    return (
        <>
            <FormField>
                <Select
                    input={{
                        value: finalStatus,
                        onChange: e => onFinalStatusChange(e.target.value)
                    }}
                    label="Final Status"
                    meta={{}}
                    schema={{ allowBlank: true, formData: STATUS_OPTIONS }}
                />
            </FormField>
            <FormField>
                <StyledCommentsField
                    label="Final Comments"
                    margin="normal"
                    minRows={3}
                    multiline
                    onChange={e => onFinalCommentsChange(e.target.value)}
                    placeholder=""
                    value={finalComments}
                    variant="filled"
                />
            </FormField>
        </>
    );
};

export default FinalReport;
